export const ADD_PRODUCT_PHRASE = 'productPhraseForm/ADD_PRODUCT_PHRASE';
export const EDIT_PRODUCT_PHRASE = 'productPhraseForm/EDIT_PRODUCT_PHRASE';
export const ADD_TABLE_PHRASE = 'productPhraseForm/ADD_TABLE_PHRASE';
export const RESET_PLACEHOLDERS = 'productPhraseForm/RESET_PLACEHOLDERS';
export const SAVE_BUTTON_CLICK = 'productPhraseForm/SAVE_BUTTON_CLICK';
export const LOAD_FORM = 'productPhraseForm/LOAD_FORM';
export const SELECT_PRODUCT_PHRASE = 'productPhraseForm/SELECT_PRODUCT_PHRASE';
export const DELETE_BUTTON_CLICK = 'productPhraseForm/DELETE_BUTTON_CLICK';
export const SELECT_FILTER = 'productPhraseForm/SELECT_FILTER';
